<template>
  <TContainer :mobile-full="true">
    <UCarousel v-slot="{ item, index }" :items="items" :ui="cottageCarousel">
      <UCard
        as="a"
        :ui="carouselCardFourWithoutBorder"
        :href="item.url"
        @click="buttonClick($event, index)"
      >
        <TLazyimg
          :src="item.image"
          alt=""
          :classes-img="cardLazyImgRounded"
          classes="aspect-h-16 aspect-w-13"
        />
        <template #footer>
          <TText variant="semibold" clamp="clamp1" classes="mb-0">
            {{ item.title }}
          </TText>
        </template>
      </UCard>
    </UCarousel>
  </TContainer>
</template>
<script setup lang="ts">
import { cottageCarousel } from '~~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import { carouselCardFourWithoutBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRounded } from '~~/modules/design-system/components/t-lazyimg/constants/config'

export interface propsInterface {
  items: {
    url: string
    image: string
    title: string
  }[]
}

defineProps<propsInterface>()
const emit = defineEmits<{
  (event: 'button-click', $event: Event, index: number): void
}>()

const buttonClick = (event: Event, index: number) => {
  emit('button-click', event, index)
}
</script>
